import angular from 'angular';
import 'angular-sanitize';
import 'ui-select';
import 'common/treeModule';
import dataManagementUsersServices from 'data_management/users/usersServices';

/**
 * @ngdoc overview
 * @name dataManagementModule.dataManagementUsersControllers
 * @description
 * # dataManagementModule.dataManagemenUsersControllers
 * Module for managing the controllers of: users.
 */
const dataManagementUsersControllers = angular.module('dataManagementModule.dataManagementUsersControllers', [
    'ngSanitize',
    'commonModule.treeModule',
    'dataManagementModule.dataManagementUsersServices',
    'ui.select'
]);

/**
 * @ngdoc controller
 * @name dataManagementModule.dataManagementUsersControllers.controller:DataManagementUsersListController
 * @description
 * Controller for Data Management Users List view
 */
dataManagementUsersControllers.controller('DataManagementUsersListController', ['$scope', 'NgTableParams', 'growl', 'DataManagementUser', 'AppsoupAPI', 'Permissions', function ($scope, NgTableParams, growl, DataManagementUser, AppsoupAPI, Permissions) {
    'use strict';
    $scope.writeAccess = Permissions.hasWriteAccess('data_management_users');
    $scope.search = {};
    $scope.isFind = false;
    $scope.check = false;
    $scope.dropdown = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: (params) => {
            $scope.isLoading = true;
            DataManagementUser.getList(params._params)
                .then((response) => {
                    params.total(response.data.total);
                    params.count(response.data.per_page);
                    params.page(response.data.current_page);
                    $scope.applications = response.applications;
                    $scope.applicationList = Object.keys($scope.applications).map((key) => {
                        return {
                            id: key,
                            name: $scope.applications[key]
                        };
                    });
                })
                .finally(() => {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.removeUser = (id, index) => {
        DataManagementUser.remove(id)
            .then((data) => {
                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.DELETE_USER');
                    $scope.tableParams.data.splice(index, 1);
                } else if (data.error) {
                    growl.error(`MODULES.USERS.${data.error}`);
                }
            });
    };

    $scope.searchUsers = (search) => {
        $scope.isFind = true;
        if (angular.isDefined($scope.dropdown.selectedApp) && $scope.dropdown.selectedApp !== null) {
            $scope.search.app_id = $scope.dropdown.selectedApp.id;
        }
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = () => {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.login_or_email)) {
            $scope.tableParams._params.login_or_email = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.app_id)) {
            $scope.tableParams._params.app_id = undefined;
        }
        if (angular.isDefined($scope.dropdown.selectedApp)) {
            $scope.dropdown.selectedApp = {};
        }
    };

    $scope.$watch('dropdown', () => {
        $scope.search.app_id = undefined;
    }, true);
}]);

/**
 * @ngdoc controller
 * @name dataManagementModule.dataManagementUsersControllers.controller:DataManagementUserPageController
 * @description
 * Controller for User Page view (new/edit user)
 */
dataManagementUsersControllers.controller('DataManagementUserPageController', ['$scope', '$rootScope', '$state', '$stateParams', '$filter', '$q', '$modal', 'growl', 'DataManagementUser', 'Client', 'LanguageService', 'Permissions', ($scope, $rootScope, $state, $stateParams, $filter, $q, $modal, growl, DataManagementUser, Client, LanguageService, Permissions) => {
    const {userId, appId} = $stateParams;

    $scope.writeAccess = Permissions.hasWriteAccess('data_management_users');
    $scope.showAdvanced = Permissions.hasSuperAdminAccess();

    $scope.user = {};
    $scope.formErrors = {};

    DataManagementUser.getAttributes(appId).then((result) => {
        let data = result.data;
        if (data.success) {
            $scope.users_www_attributes = data.attributes;
        }
    });

    // Get User Data
    if (userId) {
        DataManagementUser.get(userId)
            .then((response) => {
                if (response.success) {
                    $scope.user = response.user;
                }
            })
            .catch(() => {
                $state.go('appsoup.data_management.users', growl.error('ERROR.EMPTY_DATA'));
            }).finally(() => {
            $rootScope.doingResolve = false;
        });
    }

    $scope.save = () => {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.dataForm.$valid) {
            const user = angular.copy($scope.user);
            DataManagementUser.save(user).then((data) => {
                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.EDIT_USER');
                    $state.go('appsoup.data_management.users');
                } else {
                    $scope.formErrors = data.errors.user;
                    $scope.errors = data.errors.json_data;
                }
            });
        }
    };

    $scope.cancel = () => {
        $state.go('appsoup.data_management.users');
    };
}]);

export default dataManagementUsersControllers;
